import './eventStorySummary.css';

/** Heading plus prose paragraphs for missed, location, and character day stories. */
export default function EventStorySummary(props: { story: string }): JSX.Element {
  const paragraphs = props.story.split(/\n\s*\n/);
  return (
    <section className="event-story-summary" aria-labelledby="event-story-summary-heading">
      <h3 id="event-story-summary-heading" className="event-story-summary__heading">
        Summary of events:
      </h3>
      <div className="event-story-summary__body">
        {paragraphs.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>
    </section>
  );
}
